/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AdminRoadmapJiraGroupMappingStatus {
    EXPLICITLY_MAPPED = 'explicitly_mapped',
    SUGGESTED_NAME_MATCH = 'suggested_name_match',
    AMBIGUOUS_NAME_MATCH = 'ambiguous_name_match',
    UNMAPPED = 'unmapped',
    INVALID_TEAM = 'invalid_team',
}
